import { defineMessages } from 'react-intl';

export const statisticsMessages = defineMessages({
    title: {
        id: 'statistics',
        defaultMessage: 'Statistics',
    },
    overview: {
        id: 'overview',
        defaultMessage: 'Overview',
    },
    detailed: {
        id: 'detailed',
        defaultMessage: 'Detailed',
    },
    reports: {
        id: 'reports',
        defaultMessage: 'Reports',
    },
    totalEvents: {
        id: 'total-events',
        defaultMessage: 'Total Events',
    },
    events: {
        id: 'events',
        defaultMessage: 'Events',
    },
    exits: {
        id: 'exits',
        defaultMessage: 'Exits',
    },
    occupancy: {
        id: 'occupancy',
        defaultMessage: 'Occupancy',
    },
    daily: {
        id: 'daily',
        defaultMessage: 'Daily',
    },
    weekly: {
        id: 'weekly',
        defaultMessage: 'Weekly',
    },
    custom: {
        id: 'custom',
        defaultMessage: 'Custom',
    },
    min: {
        id: 'statistics-min',
        defaultMessage: 'Minimum',
    },
    max: {
        id: 'statistics-max',
        defaultMessage: 'Maximum',
    },
    average: {
        id: 'statistics-average',
        defaultMessage: 'Average',
    },
    generatedReports: {
        id: 'generated-reports',
        defaultMessage: 'Generated Reports',
    },
    viewReport: {
        id: 'view-report',
        defaultMessage: 'View Report',
    },
    time_period_under_30_min: {
        id: 'time_period_under_30_min',
        defaultMessage: 'Under 30 minutes',
    },
    time_period_30_60_min: {
        id: 'time_period_30_60_min',
        defaultMessage: 'From 30 to 60 minutes',
    },
    time_period_60_90_min: {
        id: 'time_period_60_90_min',
        defaultMessage: 'From 60 to 90 minutes',
    },
    time_period_90_120_min: {
        id: 'time_period_90_120_min',
        defaultMessage: 'From 90 to 120 minutes',
    },
    time_period_120_180_min: {
        id: 'time_period_120_180_min',
        defaultMessage: 'From 120 to 180 minutes',
    },
    time_period_over_180_min: {
        id: 'time_period_over_180_min',
        defaultMessage: 'Over 180 minutes',
    },
    totalNumber: {
        id: 'total-number',
        defaultMessage: 'Total number',
    },
    numberEntriesDurationStay: {
        id: 'number-entries-duration-stay',
        defaultMessage: 'Number of entries for a duration of stay',
    },
    numberEntriesTimeFrame: {
        id: 'number-entries-time-frame',
        defaultMessage: 'Number of entries for a time frame',
    },
    duration: {
        id: 'duration',
        defaultMessage: 'Duration',
    },
    timeFrame: {
        id: 'time-frame',
        defaultMessage: 'Time frame',
    },
    mostActivePeriod: {
        id: 'most-active-period',
        defaultMessage: 'Most active period',
    },
    averageVisitsHour: {
        id: 'average-visits-per-hour',
        defaultMessage: 'Average visits per hour',
    },
    mostInactivePeriod: {
        id: 'most-inactive-period',
        defaultMessage: 'Most inactive period',
    },
    filterByParkingZones: {
        id: 'filter-by-parking-zones',
        defaultMessage: 'Filter by parking zones',
    },
    parkingZones: {
        id: 'parking-zones',
        defaultMessage: 'Parking zones',
    },
    occupancyStatistics: {
        id: 'occupancy-statistics',
        defaultMessage: 'Occupancy statistics',
    },
    backToAllReports: {
        id: 'back-to-all-reports',
        defaultMessage: 'Back to all reports',
    },
    durationStatistics: {
        id: 'duration-statistic',
        defaultMessage: 'Duration statistic',
    },
    timeFrameStatistics: {
        id: 'time-frame-statistic',
        defaultMessage: 'Time frame statistic',
    },
    durationSubtitle: {
        id: 'duration-subtitle',
        defaultMessage: 'A detailed report on the duration of stays at your parking',
    },
    timeFrameSubtitle: {
        id: 'time-frame-subtitle',
        defaultMessage: 'Occupancy per each hour of the day of a given time frame',
    },
    occupancyStatisticsSubtitle: {
        id: 'occupancy-statistics-subtitle',
        defaultMessage: 'See how your parking handles occupancy, which time frames are important',
    },
    parkingStatistics: {
        id: 'parking-statistics',
        defaultMessage: 'Parking statistics',
    },
    visitsSubtitle: {
        id: 'visits-subtitle',
        defaultMessage: 'Report for all the visits in your parking',
    },
    allVisits: {
        id: 'all-visits',
        defaultMessage: 'All visits',
    },
    allVisitsSubtitle: {
        id: 'all-visits-subtitle',
        defaultMessage: 'Get a glimpse at the payments and their details in your parking',
    },
    totalNumberVisits: {
        id: 'total-number-visits',
        defaultMessage: 'Total number of visits',
    },
    totalNumberVisitsPeriod: {
        id: 'total-number-visits-period',
        defaultMessage: 'Total number of visits per the period',
    },
    vipVisits: {
        id: 'vip-visits',
        defaultMessage: 'VIP visits',
    },
    prePaidVisits: {
        id: 'pre-paid-visits',
        defaultMessage: 'Pre paid visits',
    },
    normalVisits: {
        id: 'normal-visits',
        defaultMessage: 'Normal visits',
    },
    payments: {
        id: 'payments',
        defaultMessage: 'Payments',
    },
    paymentsSubtitle: {
        id: 'payments-subtitle',
        defaultMessage: 'Report for all the visits in your parking',
    },
    allPayments: {
        id: 'all-payments',
        defaultMessage: 'All payments',
    },
    allPaymentsSubtitle: {
        id: 'all-payments-subtitle',
        defaultMessage: 'Get a glimpse at the payments and their details in your parking',
    },
    operations: {
        id: 'operations',
        defaultMessage: 'Operations',
    },
    operationsSubtitle: {
        id: 'operations-subtitle',
        defaultMessage: 'Understand what happened, where and why in your parking',
    },
    allValidations: {
        id: 'all-validations',
        defaultMessage: 'All validations',
    },
    allValidationsSubtitle: {
        id: 'all-validations-subtitle',
        defaultMessage: 'Report for all the validation operations',
    },
    makeGuestActions: {
        id: 'make-guest-actions',
        defaultMessage: 'Make guest actions',
    },
    makeGuestActionsSubtitle: {
        id: 'make-guest-actions-subtitle',
        defaultMessage: 'Report for all the make guest action operations',
    },
    manualPointActions: {
        id: 'manual-point-actions',
        defaultMessage: 'Report for all the manual point action operations',
    },
    manualPointActionsSubtitle: {
        id: 'manual-point-actions-subtitle',
        defaultMessage: 'Search for any client in the database',
    },
    visit: {
        id: 'visit',
        defaultMessage: 'Visit',
    },
    visits: {
        id: 'visits',
        defaultMessage: 'Visits',
    },
    paid: {
        id: 'paid',
        defaultMessage: 'Paid',
    },
    paidAt: {
        id: 'paid-at',
        defaultMessage: 'Paid at',
    },
    exitDatetime: {
        id: 'exited-at',
        defaultMessage: 'Exited at',
    },
    date: {
        id: 'date',
        defaultMessage: 'Date',
    },
    quantity: {
        id: 'quantity',
        defaultMessage: 'Quantity',
    },
    withoutVat: {
        id: 'without-vat-value',
        defaultMessage: 'Value without VAT',
    },
    withVat: {
        id: 'with-vat-value',
        defaultMessage: 'Value with VAT',
    },
    fiscalNoteNumber: {
        id: 'fiscal-note-number',
        defaultMessage: 'Fiscal note number',
    },
    eventType: {
        id: 'event-type',
        defaultMessage: 'Event type',
    },
    workingPlace: {
        id: 'working-place',
        defaultMessage: 'Working place',
    },
    workingPlaces: {
        id: 'working-places',
        defaultMessage: 'Working places',
    },
    category: {
        id: 'category',
        defaultMessage: 'Category',
    },
    siteName: {
        id: 'site-name',
        defaultMessage: 'Site name',
    },
    totalPayments: {
        id: 'total-payments',
        defaultMessage: 'Total payments',
    },
    totalPaymentsValue: {
        id: 'total-payments-value',
        defaultMessage: 'Total payments value',
    },
    totalPaymentsValueWithoutVat: {
        id: 'total-payments-value-without-vat',
        defaultMessage: 'Total payments value without VAT',
    },
    validationReason: {
        id: 'validation-reason',
        defaultMessage: 'Validation reason',
    },
    payment: {
        id: 'payment',
        defaultMessage: 'Payment',
    },
    paymentsByType: {
        id: 'payments-by-type',
        defaultMessage: 'Payments by type',
    },
    paymentsByCategory: {
        id: 'payments-by-category',
        defaultMessage: 'Payments by category',
    },
    operation: {
        id: 'operation',
        defaultMessage: 'Operation',
    },
    parkingZone: {
        id: 'parking-zone',
        defaultMessage: 'Parking zone',
    },
    allOperations: {
        id: 'all-operations',
        defaultMessage: 'All operations',
    },
    guestActionsOperations: {
        id: 'guest-actions-operations',
        defaultMessage: 'Guest action operations',
    },
    openReason: {
        id: 'open-reason',
        defaultMessage: 'Open reason',
    },
    pointName: {
        id: 'point-name',
        defaultMessage: 'Point name',
    },
    validationOperations: {
        id: 'validation-operations',
        defaultMessage: 'Validation operations',
    },
    manualPointActionOperations: {
        id: 'manual-point-action-operations',
        defaultMessage: 'Manual point action operations',
    },
    value: {
        id: 'value',
        defaultMessage: 'Value',
    },
    totalAmount: {
        id: 'total-amount',
        defaultMessage: 'Total amount',
    },
    viewReceipt: {
        id: 'view-receipt',
        defaultMessage: 'View receipt',
    },
    downloadReceipt: {
        id: 'download-receipt',
        defaultMessage: 'Download receipt',
    },
    digitalReceipt: {
        id: 'digital-receipt',
        defaultMessage: 'Digital receipt',
    },
    downloadCopyDescription: {
        id: 'download-copy-description',
        defaultMessage: 'Download a copy of the receipt, as it would have appeared on paper.',
    },
    loadingDigitalReceipt: {
        id: 'loading-digital-receipt',
        defaultMessage: 'Loading digital receipt...',
    },
    loadingDigitalReceiptDescription: {
        id: 'loading-digital-receipt-description',
        defaultMessage: 'Please wait while we load your digital receipt. This may take a few seconds.',
    },
    errorDigitalReceipt: {
        id: 'error-digital-receipt',
        defaultMessage: 'Error loading digital receipt',
    },
    errorDigitalReceiptDescription: {
        id: 'error-digital-receipt-description',
        defaultMessage: 'An error occurred while loading your digital receipt. Please try again later.',
    },
    hour: {
        id: 'hour',
        defaultMessage: 'Hour',
    },
    currency: {
        id: 'currency',
        defaultMessage: 'Currency',
    },
    total: {
        id: 'total',
        defaultMessage: 'Total',
    },
    enterHour: {
        id: 'enter-hour',
        defaultMessage: 'Enter hour',
    },
    enterDate: {
        id: 'enter-date',
        defaultMessage: 'Enter date',
    },
    exitHour: {
        id: 'exit-hour',
        defaultMessage: 'Exit hour',
    },
    exitDate: {
        id: 'exit-date',
        defaultMessage: 'Exit date',
    },
    paidHour: {
        id: 'paid-hour',
        defaultMessage: 'Paid hour',
    },
    paidDate: {
        id: 'paid-date',
        defaultMessage: 'Paid date',
    },
    exportingVisits: {
        id: 'exporting-visits',
        defaultMessage: 'The visits are being exported. Please do not close the browser.',
    },
    exportingPayments: {
        id: 'exporting-payments',
        defaultMessage: 'The payments are being exported. Please do not close the browser.',
    },
});
